import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const IS_OPEN_ENDED_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.isOpenEnded,
    label: "Is Open Ended",
    tooltip: CatalogReferenceDataSlugs.is_open_ended,
    type: ColumnTypes.string,
    width: 200,
    cellValue: (item) => {
        if (!item.isAsset) return null;

        const is_open_ended = item.is_open_ended;

        if (is_open_ended === null) return null;

        return is_open_ended ? "Open Ended" : "Not Open Ended";
    },
};
